export default class HandiesController {
  constructor(ContentService, $uibModal) {
    this.service = ContentService;
    this.modal = $uibModal;
  }

  $onInit(){
    this.handies =  [];
    this.service.getAccountHandies().subscribe(data => {
      this.handies = data.handies;
    })
  }

  openHandyModal(handy){
    const that = this;
    this.service.getPOSList().subscribe(points => {
      this.modal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'new-handy-template.html',
        controller: ($scope, $state, $uibModalInstance) => {
          'ngInject';
          $scope.handy = handy;
          $scope.points = points;
          $scope.name = '';
          $scope.pos_id = '';
          $scope.closeThisDialog = () => $uibModalInstance.close();
          $scope.registerHandy = () => {
            that.service.registerHandy({
              description: $scope.name,
              pos_id: $scope.pos_id
            }).subscribe(handy => {
              that.handies.push(handy);
              $scope.closeThisDialog();
            });
          }
        }
      });  
    })
  }

}

 HandiesController.$inject = ['ContentService', '$uibModal'];



// WEBPACK FOOTER //
// ./src/app/pages/handies/handies.controller.js